/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { NullEnum } from './nullEnum';
import { WalletVendorEnum } from './walletVendorEnum';

export type CreditCardMethodWalletVendor =
  | (typeof CreditCardMethodWalletVendor)[keyof typeof CreditCardMethodWalletVendor]
  | null;

export const CreditCardMethodWalletVendor = { ...WalletVendorEnum, ...NullEnum } as const;
